import React from 'react';
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import ManageTrackShipment from "../../components/ManageTrackShipment/ManageTrackShipment"
import store from "../../store";
import {Helmet} from "react-helmet";


const manageTracking = () => (
  <div className="wrapper">
      <Helmet>
          {
              store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                  return row.rowTitle === "Manage" ? row.sections.map((section) => {
                      return section.title === "Track Your Shipment" ? <meta name="description" content={section.content['seo-description']}/> : null
                  }) : null
              }) : null
          }
      </Helmet>
    <Breadcrumbs/>
    <ManageTrackShipment/>
  </div>
);

export default manageTracking;



// WEBPACK FOOTER //
// ./src/pages/manage/ManageTracking.js